import { endpoints } from "constant";
import { MainAnalytics } from "types/Analytics";
import { api } from "./http";

export const getAnalyticsRequest = async (): Promise<{ data: MainAnalytics }> =>
  await api.get(endpoints.analytics);
